import { useDispatch } from "react-redux";

import { logout } from "shared/actions/authActions";
import {
  SUPPORT_EMAIL_MAILTO,
  SUPPORT_EMAIL,
} from "shared/utils/siteConstants";

import "./ErrorPane.scss";
import LinkButton from "./LinkButton";

export interface ErrorPaneProps {
  error: Error;
}

const ErrorPane = (props: ErrorPaneProps) => {
  const error = props.error;
  // @ts-ignore
  const detail = error.response ? error.response.detail : "";
  const dispatch = useDispatch();

  return (
    <div className="ErrorPane">
      <div className="CenterMessage">
        <h2>Error</h2>
        <h4>{props.error.message}</h4>
        <h6>{detail}</h6>
        <div>
          <p>
            You can try{" "}
            <LinkButton
              onClick={() => {
                window.location.reload();
              }}
            >
              refreshing
            </LinkButton>{" "}
            the page or{" "}
            <LinkButton
              onClick={() => {
                dispatch(logout());
              }}
            >
              logging in
            </LinkButton>{" "}
            again.
          </p>
          <p>
            If the problem persists, please contact{" "}
            <a href={SUPPORT_EMAIL_MAILTO}>{SUPPORT_EMAIL}</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPane;
